import React from "react";
import { FlexBox } from "../../styles/global";
import { useDataContext } from "../../context/DataContext";
import {
  Card,
  BigCard,
  CardHeader,
  CardInfo,
  ChipsCard,
  PLineHeigth2,
} from "../DataFetcher/styled-datafetcher";
import { IoIosPeople } from "react-icons/io";
import ReactLoading from "react-loading";
import Tooltip from "@mui/material/Tooltip";
import GetHospitalData from "../GetHospitalData/GetHospitalData";

interface HospitalCardProps {
  hospitalId: string;
}

const HospitalCard: React.FC<HospitalCardProps> = ({ hospitalId }) => {
  const { loading } = useDataContext();

  if (loading)
    return (
      <ReactLoading
        type={"spinningBubbles"}
        color="#fff"
        height={667}
        width={375}
      />
    );

  const hospitalData = GetHospitalData(hospitalId);

  if (hospitalData) {
    return (
      <BigCard hospital={hospitalId}>
        <CardHeader>
          <h3>{hospitalId}</h3>
        </CardHeader>
        <FlexBox direction="column" gap="7px">
          <FlexBox gap="8px" justify="space-between">
            <ChipsCard>
              <p style={{ lineHeight: "19px" }}>Aguardando Atendimento</p>
              <span>
                {
                  (hospitalData as { PacientesAguardando: any })
                    .PacientesAguardando
                }
              </span>
              <PLineHeigth2>agora</PLineHeigth2>
            </ChipsCard>
            <ChipsCard>
              <FlexBox direction="column" gap="12px">
                <FlexBox justify="center" gap="5px">
                  <p>GAEs:</p>{" "}
                  <span>
                    {(hospitalData as { GAESAbertas: any }).GAESAbertas}
                  </span>
                </FlexBox>
                <FlexBox justify="center" gap="5px">
                  <p>Desistentes:</p>{" "}
                  <span>
                    {(hospitalData as { Desistentes: any }).Desistentes}
                  </span>
                </FlexBox>
                <PLineHeigth2>últimas 24h</PLineHeigth2>
              </FlexBox>
            </ChipsCard>
          </FlexBox>

          <span style={{ fontSize: "13px", textAlign: "center" }}>
            <b>Classificação de Risco</b>
          </span>

          <div
            className="teste"
            style={{
              border: "1px solid #cecece",
              padding: "7px 10px",
              borderRadius: "10px",
            }}
          >
            <FlexBox direction="column" gap="6px">
              <div>
                <p
                  style={{
                    fontSize: "13px",
                    marginBottom: "5px",
                    textAlign: "center",
                  }}
                >
                  <b>Pacientes aguardando atendimento (agora)</b>
                </p>

                <FlexBox gap="8px">
                  {[
                    { color: "#DE1E1F", risco: "vermelho" },
                    { color: "#E96F19", risco: "laranja" },
                    { color: "#ffce24", risco: "amarelo" },
                    { color: "#077d04", risco: "verde" },
                    { color: "#007bff", risco: "azul" },
                  ].map(({ color, risco }) => (
                    <Tooltip
                      key={risco}
                      title={risco}
                      arrow
                      slotProps={{
                        popper: {
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, -8],
                              },
                            },
                          ],
                        },
                      }}
                    >
                      <CardInfo color={color}>
                        <FlexBox
                          direction="column"
                          align="center"
                          justify="center"
                        >
                          <IoIosPeople size="25px" />
                          <span>
                            {(hospitalData as { [key: string]: any })[
                              `total_risco_${risco}`
                            ] ?? 0}
                          </span>
                        </FlexBox>
                      </CardInfo>
                    </Tooltip>
                  ))}
                </FlexBox>
              </div>
            </FlexBox>
          </div>
        </FlexBox>
      </BigCard>
    );
  } else {
    return (
      <BigCard hospital="HRBZ">
        <FlexBox width="400px" height="200px" textAling="center">
          <CardHeader>
            <p>No momento não foi possível recuperar as informações.</p>
          </CardHeader>
        </FlexBox>
      </BigCard>
    );
  }
};

export default HospitalCard;
